export default {
  GET_ALL: `#graphql
  query getBans($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getBans(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init: $init, final: $final)
    {
      docs {
        _id
        type
        value
        name
        order
        bannedBy
        createdAt
        updatedAt
      },
      totalDocs,
      limit,
      hasPrevPage,
      hasNextPage,
      page,
      totalPages,
      prevPage,
      nextPage,
      pagingCounter
    }
  }`
}



// WEBPACK FOOTER //
// ./src/graphql/ban.js